<section class="pt-2 ">
  <div class="container-style">
    <div class="row align-items-center pb-2">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6> Detalle Interfaz {{typeInterface}} </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <div class="d-flex gap-2">
          <!-- Vista Previa Contab -->
          <app-custom-button *ngIf="visiblePreview" [label]="'Vista Prev.'" [severity]="'primary'" [width]="'7rem'"
            [disabled]="disabledPreview" [icon]="'pi pi-file'" (onClick)="openPreviewModal()"></app-custom-button>
          <app-custom-modal *ngIf="visiblePreview" #preview [label]="'Vista Previa'"
            [header]="'Vista Previa - Interfaz Contable'" [children]="componentPreview" [inputs$]="inputsForPreview$"
            [output$]="outputForPreview$" hidden></app-custom-modal>

          <!-- Agregar Documentos -->
          <app-custom-button [label]="'Agregar'" [severity]="'success'" [disabled]="disabledButton" [width]="'7rem'"
            [icon]="'pi pi-file-plus'" (onClick)="openDocumentSelectionModal()"></app-custom-button>
          <app-custom-modal #documentsSelection [label]="'Seleccionar'" [header]="'Selección de documentos'"
            [children]="componentTableSelection" [inputs$]="inputsForDocumentsSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]=" !this.disabledButton " [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getAccountingInterfaceDetailById()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>